import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const legacySearchSchema = z.object({
  tab: z.string().optional(),
}).passthrough()

export const Route = createFileRoute('/_authenticated/phone/')({
  validateSearch: legacySearchSchema,
  beforeLoad: ({ search }) => {
    const { tab, ...rest } = search as Record<string, unknown>
    const segment = typeof tab === 'string' && tab ? tab : 'calls'
    throw redirect({
      to: `/phone/${segment}`,
      search: rest as Record<string, string>,
    })
  },
})
